/* eslint-disable no-nested-ternary */
import { useCallback, useEffect, useRef, useState } from 'react';

import moment from 'moment';
import { AxiosError } from 'axios';
import { useHistory } from 'react-router-dom';
import { Theme, useTheme } from '@material-ui/core';

import APIError from '../../errors/APIError';

import { ModalHandles } from '../../newComponents/Modal';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import api from '../../services/api';
import OrdersService from '../../services/OrdersService';

import { calcOrderPrice } from '../../utils/calcOrderPrice';

import { IFormaPagamentoEmpresa } from '../../interfaces/IPaymentMethod';
import { ICustomer } from '../../interfaces/ICustomer';
import { IDeliveryAddress } from '../../interfaces/IDeliveryAddress';
import { ICartItem } from '../../interfaces/ICartItem';
import { IColor } from '../../interfaces/IColor';
import { ISize } from '../../interfaces/ISize';
import { IDiscountCoupon } from '../../interfaces/IDiscountCoupon';
import { useHeader } from '../../hooks/header';
import { getCurrentOrder } from '../../utils/getCurrentOrder';
import { setCurrentOrder } from '../../utils/setCurrentOrder';
import { IDeliveryType } from '../../interfaces/IDeliveryType';
import { clearCurrentOrder } from '../../utils/clearCurrentOrder';

interface IUseNewOrder {
  cart: ICartItem[];
  companies: {
    id: number;
    name: string;
  }[];
  modalCancelRef: React.RefObject<ModalHandles>;
  modalCreateUserRef: React.RefObject<ModalHandles>;
  selectedDeliveryType: 'TAKEOUT' | 'INDOOR' | 'DELIVERY';
  selectedClient: ICustomer | null;
  setSelectedClient: React.Dispatch<React.SetStateAction<ICustomer | null>>;
  selectedAddress: any;
  selectedCompanyId: number;
  selectedCoupon: IDiscountCoupon | null;
  seletedProductId: number | null;
  seletedEditCartItemId: number | null;
  setSeletedEditCartItemId: React.Dispatch<React.SetStateAction<number | null>>;
  addItemToCart: (payload: any) => void;
  editItemToCart: (itemId: number, payload: any) => void;
  removeItemToCart: (id: number) => void;
  setDeliveryType: React.Dispatch<
    React.SetStateAction<'TAKEOUT' | 'INDOOR' | 'DELIVERY'>
  >;
  handleChangeSelectedCompany: (id: number) => void;
  setSelectedAddress: React.Dispatch<
    React.SetStateAction<IDeliveryAddress | null>
  >;
  setSelectedCoupon: React.Dispatch<
    React.SetStateAction<IDiscountCoupon | null>
  >;
  setSeletedProductId: React.Dispatch<React.SetStateAction<number | null>>;
  handleFinalizeOrder: () => Promise<void>;

  selectdePaymentMethod: {
    paymentMethod: IFormaPagamentoEmpresa;
    changeMoney: number | null;
  } | null;
  setSelectedPaymentMethod: React.Dispatch<
    React.SetStateAction<{
      paymentMethod: IFormaPagamentoEmpresa;
      changeMoney: number | null;
    } | null>
  >;
  setScheduledDelivery: React.Dispatch<React.SetStateAction<Date | null>>;
  scheduledDelivery: Date | null;
  colorsAndSizesAll: {
    colors: IColor[] | null;
    sizes: ISize[] | null;
  };

  deliveryFee: any;

  history: any;

  finalPrice: number;
  distances: { id: number; distance: number }[];

  step: number;

  discountOnTheOutside: number | null;
  setDiscountOnTheOutside: React.Dispatch<React.SetStateAction<number | null>>;
  theme: Theme;
  nextStep: () => void;
  prevStep: () => void;

  observation: string;
  setObservation: React.Dispatch<React.SetStateAction<string>>;

  asideIsClosed: boolean;
  setAsideisClosed: React.Dispatch<React.SetStateAction<boolean>>;

  asideIsOpen: boolean;
  setAsideIsOpen: React.Dispatch<React.SetStateAction<boolean>>;

  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  pagbankPixOpen: boolean;
  pagbankPixCharge: {
    orderId: number;
    status: string;
    qrCode?: string;
    copyPaste?: string;
  } | null;
  closePagbankPix: () => void;
}

export default function useNewOrder(): IUseNewOrder {
  const history = useHistory();
  const { addToast } = useToast();
  const { caixa, user } = useAuth();
  const theme = useTheme();
  const { asideIsOpen, setAsideIsOpen } = useHeader();

  const canRefetchAddresses = useRef<'auto' | 'fixed' | 'not'>('auto');
  const modalCancelRef = useRef<ModalHandles>(null);
  const modalCreateUserRef = useRef<ModalHandles>(null);

  const [pagbankPixOpen, setPagbankPixOpen] = useState(false);
  const [pagbankPixCharge, setPagbankPixCharge] = useState<{
    orderId: number;
    status: string;
    qrCode?: string;
    copyPaste?: string;
  } | null>(null);
  const [finalPrice, setFinalPrice] = useState(0);
  const [selectedCompanyId, setSelectedCompanyId] = useState(user.empresa_id);
  const [selectedClient, setSelectedClient] = useState<ICustomer | null>(() => {
    const order = getCurrentOrder();

    if (order && order?.customer) {
      return order.customer;
    }

    return null;
  });
  const [cart, setCart] = useState<ICartItem[]>(() => {
    const order = getCurrentOrder();

    if (order && order.cart) {
      return order.cart;
    }

    return [];
  });

  const [selectedDeliveryType, setDeliveryType] = useState<IDeliveryType>(
    () => {
      const order = getCurrentOrder();

      if (order && order.deliveryType) {
        return order.deliveryType;
      }

      return 'TAKEOUT';
    },
  );
  const [
    selectedAddress,
    setSelectedAddress,
  ] = useState<IDeliveryAddress | null>(() => {
    const order = getCurrentOrder();

    if (order && order.address) {
      return order.address;
    }

    return null;
  });
  const [selectedCoupon, setSelectedCoupon] = useState<IDiscountCoupon | null>(
    () => {
      const order = getCurrentOrder();

      if (order && order.selectedCoupon) {
        return order.selectedCoupon;
      }

      return null;
    },
  );
  const [seletedProductId, setSeletedProductId] = useState<number | null>(null);
  const [seletedEditCartItemId, setSeletedEditCartItemId] = useState<
    number | null
  >(null);
  const [selectdePaymentMethod, setSelectedPaymentMethod] = useState<{
    paymentMethod: IFormaPagamentoEmpresa;
    changeMoney: number | null;
  } | null>(() => {
    const order = getCurrentOrder();

    if (order && order.selectdePaymentMethod) {
      return order.selectdePaymentMethod;
    }

    return null;
  });

  const [scheduledDelivery, setScheduledDelivery] = useState<Date | null>(
    () => {
      const order = getCurrentOrder();

      if (order && order.scheduledDelivery) {
        return order.scheduledDelivery;
      }

      return null;
    },
  );
  const [deliveryFee, setDeliveryFee] = useState<any | null>(null);
  const [companies, setCompanies] = useState<{ name: string; id: number }[]>(
    [],
  );
  const [colorsAndSizesAll, setColorsAndSizesAll] = useState<{
    colors: IColor[] | null;
    sizes: ISize[] | null;
  }>({
    colors: null,
    sizes: null,
  });
  const [step, setStep] = useState(0);
  const [discountOnTheOutside, setDiscountOnTheOutside] = useState<
    number | null
  >(() => {
    const order = getCurrentOrder();

    if (order && order.discountOnTheOutside) {
      return order.discountOnTheOutside;
    }

    return null;
  });

  const [observation, setObservation] = useState(() => {
    const order = getCurrentOrder();

    if (order && order.observation) {
      return order.observation;
    }

    return '';
  });

  const [asideIsClosed, setAsideisClosed] = useState(true);
  const [distances, setDistances] = useState<
    { id: number; distance: number }[]
  >([]);

  const [isLoading, setIsLoading] = useState(false);

  const prevStep = useCallback(
    () => setStep((oldState) => (oldState > 0 ? oldState - 1 : oldState)),
    [],
  );

  const nextStep = (): void => {
    setAsideisClosed(false);

    if (cart.length === 0) {
      addToast({
        type: 'info',
        title: 'Adicione pelo menos 1 produto no carrinho.',
      });
      return;
    }

    if (!selectedDeliveryType) {
      addToast({
        type: 'info',
        title: 'Selecione o meio de entrega.',
      });
      return;
    }

    if (selectedDeliveryType === 'DELIVERY' && !selectedAddress) {
      addToast({
        type: 'info',
        title:
          'Selecione um endereço para a entrega delivery ou troque o tipo da entrega.',
      });
      return;
    }

    setAsideisClosed(true);
    setStep((oldState) => (oldState < 1 ? oldState + 1 : oldState));
  };

  const addItemToCart = (payload: Omit<ICartItem, 'id'>): void => {
    setCart((oldState) => {
      const id = oldState.reduce((acc, item) => {
        return item.id >= acc ? item.id + 1 : acc;
      }, 0);
      return [...oldState, { id, ...payload } as ICartItem];
    });
  };

  const editItemToCart = (
    itemId: number,
    payload: Omit<ICartItem, 'id'>,
  ): void => {
    setCart((oldState) => {
      const filteredItems = oldState.filter((item: any) => item.id !== itemId);

      filteredItems.push({ id: itemId, ...payload });

      return filteredItems;
    });
  };

  const removeItemToCart = (id: number): void => {
    setCart((oldState) => oldState.filter((item) => item.id !== id));
  };

  const handleFinalizeOrder = async (): Promise<void> => {
    if (cart.length === 0) {
      addToast({
        type: 'info',
        title: 'Adicione pelo menos 1 produto no carrinho.',
      });
      return;
    }

    if (!selectedDeliveryType) {
      addToast({
        type: 'info',
        title: 'Selecione o meio de entrega.',
      });
      return;
    }

    if (selectedDeliveryType === 'DELIVERY' && !selectedClient) {
      addToast({
        type: 'info',
        title: 'Selecione um cliente.',
      });
      return;
    }

    if (selectedDeliveryType === 'DELIVERY' && !selectedAddress) {
      addToast({
        type: 'info',
        title:
          'Selecione um endereço para a entrega delivery ou troque o tipo da entrega.',
      });
      return;
    }

    if (selectedDeliveryType === 'DELIVERY' && !deliveryFee) {
      addToast({
        type: 'info',
        title: 'Nenhuma taxa de entrega encontrada para este endereço.',
      });
      return;
    }

    if (!selectdePaymentMethod) {
      addToast({
        type: 'info',
        title: 'Selecione uma forma de pagamento.',
      });
      return;
    }

    if (finalPrice < 0) {
      addToast({
        type: 'info',
        title: 'O valor final não pode ser abaixo de zero.',
      });
      return;
    }

    const paymentSigla =
      selectdePaymentMethod.paymentMethod.forma_pagamento.sigla || '';

    if (paymentSigla === 'pagbank_credit_card') {
      addToast({
        type: 'info',
        title:
          'No PDV, use PagBank PIX. O cartão PagBank está disponível no checkout do site.',
      });
      return;
    }

    if (
      selectdePaymentMethod.paymentMethod.forma_pagamento.descricao ===
        'Dinheiro' &&
      selectdePaymentMethod.changeMoney !== 0 &&
      finalPrice > (selectdePaymentMethod.changeMoney || 0)
    ) {
      addToast({
        type: 'info',
        title:
          'O valor em dinheiro precisa ser igual ou superior ao valor total ou igual a zero.',
      });
      return;
    }

    try {
      setIsLoading(true);

      const response = await OrdersService.createOrder({
        cashierId: caixa.id,
        deliveryFeeId: deliveryFee?.id ?? undefined,
        companyId: user.empresa_id,
        selectedCompanyId,
        companyPaymentMethodId: selectdePaymentMethod.paymentMethod.id,
        extraDiscount: discountOnTheOutside ?? 0,
        items: cart.map((item) => {
          return {
            productId: item.compositeProduct.product.id,
            observation: item.observation || undefined,
            quantity: item.quantity,
            sizeId:
              item?.childOrderItems[0]?.produto?.grids[0].sizeId ?? undefined,
            gridId: item.gridProduct?.id ?? undefined,
            complements: item.compositeProduct.complements.map((comp) => {
              return {
                id: comp.complement.id,
                quantity: comp.quantity,
              };
            }),
            childOrderItems: item.childOrderItems.map((grid: any) => {
              return {
                productId: grid.produto.id,
                quantity: grid.quantidade,
              };
            }),
          };
        }),
        orderType:
          selectedDeliveryType === 'DELIVERY'
            ? 'DELIVERY'
            : selectedDeliveryType === 'INDOOR'
            ? 'INDOOR'
            : 'TAKEOUT',
        changeMoney: selectdePaymentMethod.changeMoney
          ? selectdePaymentMethod.changeMoney - finalPrice
          : undefined,
        customerId: selectedClient?.id ?? undefined,
        deliveryAddressId:
          selectedDeliveryType === 'DELIVERY' ? selectedAddress?.id : undefined,
        discountCouponId: selectedCoupon?.id ?? undefined,
        observation:
          selectedDeliveryType === 'INDOOR'
            ? `Consumo no local - ${observation}`
            : observation || undefined,
        scheduledAt: scheduledDelivery
          ? moment(scheduledDelivery).utcOffset(0, true).format()
          : undefined,
      });

      if (paymentSigla === 'pagbank_pix') {
        const charge = await OrdersService.createPagBankPix(
          user.empresa_id,
          caixa.id,
          response.id,
        );

        setPagbankPixCharge(charge);
        setPagbankPixOpen(true);
        setIsLoading(false);

        const poll = window.setInterval(async () => {
          try {
            const current = await OrdersService.showOrder(
              user.empresa_id,
              caixa.id,
              response.id,
            );
            const paymentStatus = (current.orderPayment as any)?.status;
            const orderStatus = (current as any).status;

            if (paymentStatus === 'PAID' || orderStatus !== 11) {
              window.clearInterval(poll);
              setPagbankPixOpen(false);
              addToast({
                type: 'success',
                title: 'Pagamento confirmado.',
              });
              clearCurrentOrder();
              if (user.empresa_id !== selectedCompanyId) {
                history.push(`/monitor_pedidos`);
              } else {
                history.push(
                  `/monitor_pedidos?orderId=${response.id}&status=new`,
                );
              }
            }
          } catch (pollError) {
            console.log(pollError);
          }
        }, 3000);

        return;
      }

      addToast({
        type: 'success',
        title: 'Pedido realizado.',
      });

      setIsLoading(false);

      clearCurrentOrder();
      if (user.empresa_id !== selectedCompanyId) {
        history.push(`/monitor_pedidos`);
      } else {
        history.push(`/monitor_pedidos?orderId=${response.id}&status=new`);
      }
    } catch (err) {
      console.log(err);

      setIsLoading(false);
      if (err instanceof APIError) {
        addToast({
          title: err.message,
          type: 'error',
        });
        return;
      }
      addToast({
        type: 'error',
        title: 'Erro ao criar pedido. Tente novamente.',
      });
    }
  };

  useEffect(() => {
    canRefetchAddresses.current = 'auto';
  }, [selectedAddress]);

  useEffect(() => {
    const fetchCompanies = async (): Promise<void> => {
      const { data } = await api.get(`companies/${user.empresa_id}/all`);
      setCompanies(
        data.map((company: any) => ({
          id: company.id,
          name: company.fantasyName,
        })),
      );
      setSelectedCoupon(null);
    };

    fetchCompanies();
  }, [user.empresa_id]);

  useEffect(() => {
    const fetchDataColors = async (): Promise<void> => {
      const { data } = await api.get(`companies/${selectedCompanyId}/colors`);
      setColorsAndSizesAll((oldState) => ({ ...oldState, colors: data }));
    };

    const fetchDataSizes = async (): Promise<void> => {
      const { data } = await api.get(
        `companies/${selectedCompanyId}/sizes/all`,
      );
      setColorsAndSizesAll((oldState) => ({ ...oldState, sizes: data }));
    };

    fetchDataColors();
    fetchDataSizes();
  }, [selectedCompanyId]);

  const handleChangeSelectedCompany = (id: number): void => {
    canRefetchAddresses.current = 'fixed';
    setSelectedCompanyId(id);
  };

  useEffect(() => {
    if (selectedAddress && canRefetchAddresses.current !== 'not') {
      setCurrentOrder({ address: selectedAddress });
      const loadValidateAddress = async (): Promise<void> => {
        try {
          const { data } = await api.post(
            `companies/${selectedCompanyId}/deliveryFee/${selectedAddress.id}`,
            {
              value: finalPrice,
              productsIds: cart.map((item) => item.compositeProduct.product.id),
            },
          );

          if (data.list.length && canRefetchAddresses.current === 'auto') {
            const closest = (data.list as {
              id: number;
              distance: number;
            }[]).reduce(
              (acc, loc) => {
                return acc.distance < loc.distance ? acc : loc;
              },
              { id: 0, distance: Number.POSITIVE_INFINITY },
            );

            if (closest.id) {
              canRefetchAddresses.current = 'not';
              setSelectedCompanyId(closest.id);
            }
          }

          setDistances(data.list);
          setDeliveryFee(data);
        } catch (error) {
          setCurrentOrder({ address: null });
          setSelectedAddress(null);
          setDeliveryFee(null);
          setDistances([]);
          if ((error as AxiosError).response?.status === 404) {
            addToast({
              title: (error as AxiosError).response?.data.message,
              type: 'error',
            });
            return;
          }
          addToast({
            type: 'error',
            title: 'Erro ao validar endereço de entrega',
          });
        }
      };
      loadValidateAddress();
    } else if (!selectedAddress) {
      setDeliveryFee(null);
      setDistances([]);
    }
  }, [
    addToast,
    selectedAddress,
    user.empresa_id,
    selectedCompanyId,
    cart,
    finalPrice,
  ]);

  useEffect(() => {
    let result = 0;

    const itemsValue = cart
      .filter((item) => item.deletedAt === undefined)
      .map((item) => calcOrderPrice(item))
      .reduce((acc: number, cur: number) => Number(acc) + Number(cur), 0);

    const deliveryValue = deliveryFee
      ? Number(deliveryFee.value) -
        (deliveryFee.discount ? Number(deliveryFee.discount) : 0)
      : 0;
    let couponValue = 0;

    if (selectedCoupon?.type === 1) {
      couponValue = +selectedCoupon.value;
    } else if (selectedCoupon) {
      couponValue =
        cart
          .filter((item) => item.deletedAt === undefined)
          .map((item) => calcOrderPrice(item))
          .reduce((acc: number, cur: number) => Number(acc) + Number(cur), 0) *
        (+selectedCoupon.value / 100);
    }

    result =
      itemsValue - couponValue + deliveryValue - (discountOnTheOutside ?? 0);

    setCurrentOrder({ cart });
    setFinalPrice(result);
  }, [cart, deliveryFee, discountOnTheOutside, selectedCoupon]);

  useEffect(() => {
    let coupon = selectedCoupon;

    if (!selectedClient && selectedCoupon) {
      coupon = null;
    }

    setCurrentOrder({ customer: selectedClient, selectedCoupon });
    setSelectedCoupon(coupon);
  }, [selectedClient, selectedCoupon]);

  useEffect(() => {
    if (selectedCoupon) {
      const itemsValue = cart
        .filter((item) => !item.deletedAt)
        .map((item) => calcOrderPrice(item))
        .reduce((acc: number, cur: number) => Number(acc) + Number(cur), 0);

      if (itemsValue < +selectedCoupon?.value) {
        setSelectedCoupon(null);
        addToast({
          type: 'info',
          title: 'O cupom foi removido.',
        });
      }
    }
  }, [addToast, cart, selectedCoupon]);

  useEffect(() => {
    setCurrentOrder({ deliveryType: selectedDeliveryType });
  }, [selectedDeliveryType]);

  useEffect(() => {
    setCurrentOrder({ discountOnTheOutside });
  }, [discountOnTheOutside]);

  useEffect(() => {
    setCurrentOrder({ observation });
  }, [observation]);

  useEffect(() => {
    setCurrentOrder({ selectdePaymentMethod });
  }, [selectdePaymentMethod]);

  useEffect(() => {
    setCurrentOrder({ scheduledDelivery });
  }, [scheduledDelivery]);

  return {
    modalCancelRef,
    companies,
    modalCreateUserRef,
    selectedCompanyId,
    handleChangeSelectedCompany,
    selectedDeliveryType,
    setDeliveryType,
    selectedClient,
    setSelectedClient,
    selectedAddress,
    setSelectedAddress,
    selectedCoupon,
    setSelectedCoupon,
    seletedProductId,
    setSeletedProductId,
    cart,
    addItemToCart,
    editItemToCart,
    distances,
    removeItemToCart,
    handleFinalizeOrder,
    selectdePaymentMethod,
    setSelectedPaymentMethod,
    scheduledDelivery,
    setScheduledDelivery,
    seletedEditCartItemId,
    setSeletedEditCartItemId,
    colorsAndSizesAll,
    history,
    deliveryFee,
    finalPrice,
    step,

    discountOnTheOutside,
    setDiscountOnTheOutside,

    theme,

    nextStep,
    prevStep,

    observation,
    setObservation,

    asideIsClosed,
    setAsideisClosed,

    asideIsOpen,
    setAsideIsOpen,

    isLoading,
    setIsLoading,
    pagbankPixOpen,
    pagbankPixCharge,
    closePagbankPix: () => setPagbankPixOpen(false),
  };
}
